import { Box, Text } from '@chakra-ui/react';

export default function ErrorComponent() {
	return (
		<Box p="6">
			<Text mb="3">Something went wrong</Text>
			<Text>If the problem persists write to info@timetime.in to get support 🙏</Text>
		</Box>
	);
}
